import { css } from "@emotion/react";
import settings from "@settings";

export const underline = css({
    borderBottom: `4px solid transparent`,
})


export const dummyContainer = css({
    position: 'relative',
    width: '540px',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: settings.padding.medium
})

export const dummyContainerMobile = css({
    position: 'relative',
    width: '100%',
    height: '180px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: settings.padding.medium
})

export const overlay = css({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
})

export const nextPageLinkMobile = settings.mq({
    color: `${settings.colors.white} !important`,
    textDecoration: 'none !important',
    width: '100%',
    height: '100%',
    position: 'relative',
    fontSize: '24px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    zIndex: 3
})

export const nextPageContainer = css({
    position: 'absolute',
    bottom: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '300px',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
})

export const nextLinkHeader = css({
    color: `${settings.colors.white} !important`, 
    textAlign: 'center', 
    fontSize: '24px !important',
    margin: 0
})

export const nextPageLink = css({
    color: `settings.colors.white`,
    textDecoration: 'none !important',
    fontSize: '30px',
    fontWeight: 500,

})